<p>consulta-registros works!</p>
